import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Divider, IconButton, Checkbox, FormControlLabel } from "@mui/material";

function VehicleCard({ color, icon, title, journeys, selectedJourneys, onToggleJourney, onDelete }) {
  return (
    <Card
      sx={{
        width: "100%",
        transition: "0.2s",
        "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
      }}
    >
      <MDBox p={2} display="flex" alignItems="flex-start" justifyContent="space-between">
        {/* Left side: Vehicle info */}
        <MDBox display="flex" flexDirection="column" flex={1}>
          <MDBox display="flex" alignItems="center" gap={1}>
            <Icon fontSize="medium" color={color}>
              {icon || "directions_bus"}
            </Icon>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              {title}
            </MDTypography>
          </MDBox>

          {/* Description with checkboxes for journeys */}
          {journeys && journeys.length > 0 && (
            <>
              <Divider sx={{ my: 1 }} />
              <MDBox display="flex" flexDirection="column" gap={0.5}>
                {journeys.map((j) => (
                  <FormControlLabel
                    key={j.journeyId}
                    control={
                      <Checkbox
                        size="small"
                        checked={!!selectedJourneys[j.journeyId]}
                        onChange={(e) => {
                          e.stopPropagation();
                          onToggleJourney(j.journeyId);
                        }}
                      />
                    }
                    label={
                      <MDTypography
                        variant="button"
                        fontWeight="regular"
                        color={selectedJourneys[j.journeyId] ? "success" : "text"}
                      >
                        {j.journeyName} {j.type} ({j.interval.startTime}-{j.interval.endTime})
                      </MDTypography>
                    }
                  />
                ))}
              </MDBox>
            </>
          )}
        </MDBox>

        {/* Right side: Delete icon */}
        {onDelete && (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <Icon color="error">delete</Icon>
          </IconButton>
        )}
      </MDBox>
    </Card>
  );
}

VehicleCard.defaultProps = {
  color: "info",
  icon: "directions_bus",
  journeys: [],
  selectedJourneys: {},
  onToggleJourney: () => {},
  onDelete: null,
};

VehicleCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  journeys: PropTypes.array,
  selectedJourneys: PropTypes.object,
  onToggleJourney: PropTypes.func,
  onDelete: PropTypes.func,
};

export default VehicleCard;
